import { useEffect, useRef, useState } from "react";

export default function useCountryCode() {
  const [countryCode, setCountryCode] = useState();
  const [countryCodes, setCountryCodes] = useState([]);
  const lang = useRef({
    tr: "Turkey",
    az: "Azerbaijan",
    eg: "Egypt",
    sa: "Saudi Arabia",
    ae: "United Arab Emirates",
  }).current;

  useEffect(() => {
    if (location.pathname !== "/merchants") {
      location.href = "/merchants";
    }

    const data = JSON.parse(localStorage.getItem("userData"));

    if (data?.countryCodes) {
      setCountryCodes(data.countryCodes);

      const selectedCountryCode = localStorage.getItem("x-country-code");


      if (selectedCountryCode) {
        if (data.countryCodes.includes(selectedCountryCode)) {
          localStorage.setItem("x-country-code", selectedCountryCode);
          setCountryCode(selectedCountryCode);
        } else {
          localStorage.setItem("x-country-code", data.countryCodes[0]);
          setCountryCode(data.countryCodes[0]);
        }
      } else {
        localStorage.setItem("x-country-code", data.countryCodes[0]);
        setCountryCode(data.countryCodes[0]);
      }
    } else {
      console.log("debug:", "no data");
    }

    // todo: bcrn
    if (localStorage.getItem("x-country-code") === "tr") {
      document.querySelector('a[href="/revenue/card-az"]').remove();
      document.querySelector('a[href="/revenue/non-card-az"]').remove();
      document.querySelector('a[href="/onboard-stats/az"]').remove();
      document.querySelector('a[href="/az-sales"]').remove();
    };
    if (localStorage.getItem("x-country-code") === "az") {
      document.querySelector('a[href="/revenue/card-tr"]').remove();
      document.querySelector('a[href="/revenue/non-card-tr"]').remove();
      document.querySelector('a[href="/onboard-stats/tr"]').remove();
      document.querySelector('a[href="/sales"]').remove();
    };

  }, []);

  const setSelectedCountryCode = (code) => {
    localStorage.setItem("x-country-code", code);
    setCountryCode(code);
    setTimeout(() => {
      document.location.reload();
    }, 300);
  };

  return {
    countryCode: countryCode || countryCodes[0],
    countryCodes: countryCodes ? countryCodes.map((cc) => ({ value: cc, label: lang[cc] || "N/A" })) : [],
    setCountryCode: setSelectedCountryCode,
  };
}
